import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memo } from 'react';
import PropTypes from 'prop-types';
import { TEXT } from '../../config/constants';
import Button from '../../components/Button';
import css from './AddToBag.module.scss';
import Price, { displayCAP } from '../../components/Price';
import formatPrice from '../../utils/strings/formatPrice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var INVENTORY_TEXT = TEXT.inventory;

var getUnavailableText = function getUnavailableText(_ref) {
  var comingSoon = _ref.comingSoon,
      displayWaitlist = _ref.displayWaitlist;

  if (!displayWaitlist) {
    return INVENTORY_TEXT.soldOut;
  }

  if (comingSoon) {
    return "".concat(INVENTORY_TEXT.comingSoon, " - ").concat(INVENTORY_TEXT.jtwl);
  }

  return "".concat(INVENTORY_TEXT.soldOut, " - ").concat(INVENTORY_TEXT.jtwl);
};

var CTA = /*#__PURE__*/memo(function (_ref2) {
  var available = _ref2.available,
      compareAtPrice = _ref2.compareAtPrice,
      comingSoon = _ref2.comingSoon,
      displayWaitlist = _ref2.displayWaitlist,
      price = _ref2.price,
      onShowWaitlist = _ref2.onShowWaitlist,
      onAddToBag = _ref2.onAddToBag,
      submitting = _ref2.submitting,
      title = _ref2.title;
  var showCAP = compareAtPrice && displayCAP(compareAtPrice, price);
  var capLabel = showCAP ? "Original price ".concat(formatPrice(compareAtPrice), ". ") : '';
  var priceLabel = "Price ".concat(formatPrice(price), ".");
  var buttonProps = {
    'aria-label': "Add ".concat(title, " to your cart. ").concat(priceLabel, " ").concat(capLabel, "Redirects to cart page."),
    big: true,
    full: true,
    title: TEXT.addToBag
  };

  if (submitting) {
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
      disabled: true,
      children: "Doing Things"
    }));
  }

  if (!available) {
    var unavailableText = getUnavailableText({
      comingSoon: comingSoon,
      displayWaitlist: displayWaitlist
    });
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
      "aria-label": "Product Unavailable: ".concat(unavailableText),
      disabled: !displayWaitlist,
      onClick: onShowWaitlist,
      title: "Product Unavailable",
      children: unavailableText
    }));
  }

  return /*#__PURE__*/_jsxs(Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
    onClick: onAddToBag,
    "data-ov-event": "add-to-bag",
    children: [TEXT.addToBag, "\xA0", /*#__PURE__*/_jsx(Price, {
      className: css.price,
      compareAtPrice: compareAtPrice,
      price: price
    })]
  }));
});
CTA.displayName = 'ProductAddToBagCTA';
CTA.defaultProps = {
  submitting: false
};
CTA.propTypes = {
  available: PropTypes.bool.isRequired,
  compareAtPrice: PropTypes.number.isRequired,
  comingSoon: PropTypes.bool.isRequired,
  displayWaitlist: PropTypes.bool.isRequired,
  onAddToBag: PropTypes.func.isRequired,
  onShowWaitlist: PropTypes.func.isRequired,
  price: PropTypes.number.isRequired,
  submitting: PropTypes.bool,
  title: PropTypes.string
};
export default CTA;